<template>
  <span class="kbd-combo">
    <template v-for="(chip, index) in chips" :key="index">
      <span v-if="chip === 'then'" class="kbd-combo__then">then</span>
      <kbd v-else class="kbd-combo__key">{{ chip }}</kbd>
    </template>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { formatCombo } from '@lib/shortcuts';

const { combo } = defineProps<{ combo: string }>();

const chips = computed(() => formatCombo(combo));
</script>

<style scoped lang="scss">
@import '@styles/variables';

.kbd-combo {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;

  &__key {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2rem;
    padding: 0.2rem 0.5rem;
    border: 1px solid $c-hairline;
    border-radius: 0.4rem;
    background: $c-surface-muted;
    color: $c-ink-soft;
    font-family: inherit;
    font-size: 1.1rem;
    line-height: 1.4rem;
  }

  &__then {
    color: $c-ink-soft;
    font-size: 1.1rem;
  }
}
</style>
